import { StyledButton, StyledIconButton } from './styles';
import {
  CircularProgress,
  SvgIconProps,
  SxProps,
  Theme,
  ButtonProps as MuiButtonProps,
} from '@mui/material';
import { ReactElement, ReactNode } from 'react';

type IconType = ReactElement<SvgIconProps>;
interface ButtonProps extends MuiButtonProps {
  title?: string;
  onlyText?: boolean;
  outlined?: boolean;
  disable?: boolean;
  startIcon?: IconType;
  endIcon?: IconType;
  iconButton?: ReactNode | null;
  height?: string;
  width?: string;
  onClick?: () => void;
  loading?: boolean;
  sx?: SxProps<Theme>;
  sizeBtn?: string;
}

const Button = ({
  title = '',
  onlyText = false,
  outlined = false,
  disable = false,
  startIcon,
  endIcon,
  iconButton,
  height,
  width,
  color = 'primary',
  onClick = () => {},
  loading = false,
  sx,
  size,
  sizeBtn,
}: ButtonProps) => {
  return iconButton ? (
    <StyledIconButton
      aria-label="delete"
      disabled={disable}
      color={color}
      height={sizeBtn ?? size ?? height}
      width={sizeBtn ?? size ?? width}
      onClick={onClick}
      sx={sx}
    >
      {iconButton}
    </StyledIconButton>
  ) : (
    <StyledButton
      sx={sx}
      color={color}
      variant={onlyText ? 'text' : outlined ? 'outlined' : 'contained'}
      disabled={disable}
      startIcon={startIcon}
      endIcon={endIcon}
      height={sizeBtn ?? size ?? height}
      width={sizeBtn ?? size ?? width}
      onClick={onClick}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : title}
    </StyledButton>
  );
};

export default Button;
